import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import 'src/app/components/Footer.scss';
import backgroundImage from 'src/assets/images/network.png';


const Footer = ({ customClass, mobile }) => {
  const classList = classNames({
    'footer--mobile': mobile
  });

  // eslint-disable-next-line max-len
  const regulationsLink = 'http://grupapracuj.pl/grupa-kapitalowa/regulamin/?_ga=2.95700380.1886443092.1524467419-307143718.1523602260';
  // eslint-disable-next-line max-len
  const cookiesLink = 'http://grupapracuj.pl/grupa-kapitalowa/polityka-plikow-cookie/?_ga=2.7299890.1886443092.1524467419-307143718.1523602260';

  return (
    <div styleName={ classList } className={ customClass }>
      <div styleName="footer__copyright">© Grupa Pracuj sp.&nbsp;z&nbsp;o.o.</div>
      <a
        href={ regulationsLink }
        target="_blank"
        rel="noopener noreferrer"
        title="Regulamin"
        styleName="footer__regulations"
      >
        Regulamin
      </a>
      <div styleName="footer__vertical-separator"/>
      <a
        href="https://grupapracuj.pl/polityka-prywatnosci/"
        target="_blank"
        rel="noopener noreferrer"
        title="Polityka prywatności"
        styleName="footer__privacy"
      >
        Polityka prywatności
      </a>
      <a
        href={ cookiesLink }
        target="_blank"
        rel="noopener noreferrer"
        title="Polityka Cookies"
        styleName="footer__cookies"
      >
        Polityka plików cookies
      </a>
      <div styleName="footer__horizontal-separator"/>
      <div styleName="footer__network" style={ { backgroundImage: `url(${backgroundImage.src})` } }/>
    </div>
  );
};

Footer.propTypes = {
  customClass: PropTypes.string.isRequired,
  mobile: PropTypes.bool
};

Footer.defaultProps = {
  mobile: false
};

export default Footer;
